// @ts-nocheck

import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../../db/db";
import CarePlan from "../../components/CarePlan";
import Attendance from "../../components/Forms/Attendance";
import { useState, useEffect } from "react";
import ClientPicker from "../../components/carePlan/ClientPicker";
import ClientProfile from "../../components/carePlan/ClientProfile";
import Tasks from "../../components/Forms/Tasks";
import ActivityForm from "../../components/Forms/ActivityForm";
import ActivityLogs from "../../components/Forms/ActivityLogs";
import IssueForm from "../../components/Forms/IssueForm";
import IssueLogs from "../../components/Forms/IssueLogs";
import IncidentForm from "../../components/Forms/IncidentForm";
import HandoverNotes from "../../components/Visit/HandoverNotes";
import RiskAssesments from "../../components/Visit/RiskAssessments";
import IncidentLogs from "../../components/Forms/IncidentLogs";
import ExpensesForm from "../../components/Forms/ExpensesForm";
import ExpenseLogs from "../../components/Forms/ExpenseLogs";
import BodyMapForm from "../../components/Forms/BodyMapForm";
import BodyMapLogs from "../../components/Forms/BodyMapLogs";
import GenericForms from "../../components/GenericForms/Forms";
import ClientInfo from "../../components/ClientInfo/ClientInfo";
import DesirableOutcomes from "../../components/carePlan/ClientDesirableOutcomes";
import TimeFromStart from "../../components/Visit/TimeFromStart";
import FormResponses from "../../components/GenericForms/FormResponses";
// import posthog from "posthog-js";
export const Route = createFileRoute("/visits/$visitId/details")({
  component: RouteComponent,
});

function parseVisitJson(value) {
  if (!value) {
    return undefined;
  }

  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
}

function getVisitLength(visit) {
  if (!visit?.start_time || !visit?.finish_time) {
    return 0;
  }

  const start = new Date(`1970-01-01T${visit.start_time}`);
  const end = new Date(`1970-01-01T${visit.finish_time}`);
  return (end - start) / 3600000;
}

function VisitTab({ label, disabled = false, children }) {
  return (
    <>
      <input
        type="radio"
        name="visit"
        className="tab"
        aria-label={label}
        defaultChecked={label === "Visit"}
        disabled={disabled}
      />
      <div className="tab-content ">{children}</div>
    </>
  );
}

function RouteComponent() {
  const [client, setClient] = useState();
  const { visitId } = Route.useParams();
  const navigate = useNavigate();
  const visit = useLiveQuery(() => db.visits.get(Number(visitId)));
  const [visitCompleted, setVisitCompleted] = useState(false);
  const [propertySelected, setPropertySelected] = useState(false);
  const visitLength = getVisitLength(visit);
  const clients = parseVisitJson(visit?.linkedclients) ?? [];
  const clientIDs = clients.map((linkedClient) => linkedClient[" clientid "]);
  const property = parseVisitJson(visit?.propinfo);

  const attendance = useLiveQuery(
    () => (visit ? db.attendances.get(visit["id"]) : undefined),
    [visit]
  );


  const nextVisit = useLiveQuery(
    () =>
      visit
        ? db.visits
            .where("start_time")
            .above(visit["start_time"])
            .and((item) => item.linkedclients !== "")
            .first()
        : undefined,
    [visit]
  );
  const prevVisit = useLiveQuery(
    () =>
      visit
        ? db.visits
            .where("start_time")
            .below(visit["start_time"])
            .and((item) => item.linkedclients !== "")
            .first()
        : undefined,
    [visit]
  );
  

  useEffect(() => {
    if (visit) {
      if (visit["linkedclients"] !== "") {
        return;
      } else {
        navigate({
          to: "/visits",
        });
      }
    }
  }, [visit, navigate]);

  useEffect(() => {
    if (!clientIDs.length) {
      if (client !== undefined) {
        setClient(undefined);
      }
      return;
    }

    if (!clientIDs.some((id) => String(id) === String(client))) {
      setClient(clientIDs[0]);
    }
  }, [clientIDs, client]);

  const carePlans = useLiveQuery(
    () => (clientIDs.length ? db.carePlans.bulkGet(clientIDs) : []),
    [clientIDs]
  );
  const filteredCarePlans = carePlans?.filter((item) => item) ?? [];
  const carePlan = filteredCarePlans.find((item) => item["id"] == client);
  const showPropertyPicker = {
    needsPleaseSelect: false,
    property,
    propertySelected,
    setPropertySelected,
  };

  const renderClientPicker = (extraProps = {}) => (
    <ClientPicker
      clients={clients}
      client={client}
      setClient={setClient}
      {...extraProps}
    />
  );

  const renderTabWithPicker = (label, content, extraPickerProps = {}) => (
    <VisitTab label={label}>
      {renderClientPicker(extraPickerProps)}
      {content}
    </VisitTab>
  );

  if (!visit) return null;
  return (
    <div className="flex-col w-full">
      {/* name of each tab group should be unique */}
      <div className="md:flex-row flex-col flex items-start mb-4">
        <h2 className="text-3xl">{visit["for"]}</h2>
        <div className="flex justify-between items-center gap-2 pt-2">
          <span className="badge badge-accent text-xs">{visit["type"]}</span>
          <span className="badge badge-accent text-xs">
            {visit["start_time"]} - {visit["finish_time"]}
          </span>

          <div className="p-2 bg-accent rounded-box text-accent-content text-xs">
            <span className="countdown font-mono text-accent-content">
              <span
                style={{
                  "--value": visitLength < 1 ? visitLength * 60 : visitLength,
                }}
                aria-live="polite"
                aria-label={""}
              >
                {visitLength < 1 ? 60 * visitLength : visitLength}
              </span>
            </span>
            {visitLength < 1 ? "min" : visitLength == 1 ? "hr" : "hrs"}
          </div>
        </div>
        <TimeFromStart
          attendance={attendance}
          key={JSON.stringify(attendance)}
        />
      </div>
      <div className="tabs tabs-box">
        <VisitTab label="Visit">
          <Attendance
            visit={visit}
            visitLength={visitLength}
            setVisitCompleted={setVisitCompleted}
            highlightNote={visit["highlight_note"]}
          />
        </VisitTab>
        <>
          {renderTabWithPicker(
            "Care Plans",
            <>
            <div className="divider">Care Plan</div>
            {client && <DesirableOutcomes client={client} />}
            {carePlan ? (
              <>
                <ClientProfile carePlan={carePlan} />
                <CarePlan carePlan={carePlan} />
              </>
            ) : (
              <div role="alert" className="alert alert-warning">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 shrink-0 stroke-current"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span>No Care plan available</span>
              </div>
            )}
            </>
          )}
          <VisitTab label="Tasks" disabled={visitCompleted}>
            {renderClientPicker()}
            <div className="divider">Tasks</div>
            {client && visit["for_req_id"] && (
              <Tasks
                visit={visit}
                for_req_id={visit["for_req_id"]}
                clientId={client}
                type={visit["type"]}
              />
            )}
          </VisitTab>
          {renderTabWithPicker(
            "Body Map",
            <>
            <div className="divider">Body Map</div>
            <BodyMapForm
              clientId={client}
              visitId={visitId}
              type={visit["type"]}
            />
            {client && <BodyMapLogs client={client} />}
            </>
          )}
          <>
            {renderTabWithPicker(
              "Record a Log",
              <>
              <div className="divider">Record a Log</div>
              <ActivityForm
                clientId={client}
                visitId={visitId}
                type={visit["type"]}
              />
              {client && <ActivityLogs clientId={client} />}
              </>
            )}
          </>

          {renderTabWithPicker(
            "Issues",
            <>
            <div className="divider">Issues to highlight</div>
            <IssueForm
              clientId={client}
              visitId={visitId}
              type={visit["type"]}
            />
            {client && (
              <IssueLogs
                key={JSON.stringify(client)}
                visitId={visitId}
                clientId={client}
              />
            )}
            </>
          )}
          {renderTabWithPicker(
            "Forms",
            <>
            <div className="divider">Forms</div>

            <GenericForms
              key={propertySelected ? property : client}
              clientOrStaffID={propertySelected ? property : client}
              type={propertySelected ? "property" : "client"}
            />
            </>,
            showPropertyPicker
          )}
          <FormResponses
            key={`responses ${client}`}
            clientOrStaffID={client}
            type={"client"}
            showClientPicker={true}
            clients={clients}
          />
          {renderTabWithPicker(
            "Incidents",
            <>
            <div className="divider">Incidents</div>
            <IncidentForm
              clientId={client}
              visitId={visitId}
              type={visit["type"]}
            />
            {client && <IncidentLogs clientId={client} />}
            </>
          )}

          {renderTabWithPicker(
            "Handover Notes",
            <>
            <div className="divider">Handover Notes</div>
            <HandoverNotes
              key={`${visitId}${client}`}
              visitId={visitId}
              clientId={client}
            />
            </>
          )}
          {renderTabWithPicker(
            "Risk Assessments",
            <>
            <div className="divider">Risk Assessments</div>
            <RiskAssesments clientId={client} />
            </>
          )}
          {(visit["type"] == "SL" || visit["type"] == "Com Out") && (
            <VisitTab label="Expenses">
              {renderClientPicker(showPropertyPicker)}
                <div className="divider">Expenses</div>
                <ExpensesForm
                  clientId={client}
                  visitId={visitId}
                  property={propertySelected && property["propid"]}
                  type={visit["type"]}
                />
                <ExpenseLogs visitId={visitId} />
            </VisitTab>
          )}
          {renderTabWithPicker(
            "Client Information",
            <>
            <div className="divider">Client Information</div>
            <ClientInfo
              key={client}
              clients={clients}
              client={client}
              setClient={setClient}
              needsPleaseSelect={false}
              property={property}
              setPropertySelected={setPropertySelected}
              clientId={client}
              visitId={visitId}
              property={propertySelected && property["propid"]}
            />
            </>,
            showPropertyPicker
          )}
        </>
      </div>
      <div className="join grid grid-cols-3 my-5">
        {prevVisit && (
          <Link
            key={prevVisit}
            className="join-item btn btn-sm"
            to={`/visits/${prevVisit["id"]}/details`}
            reloadDocument={true}
          >
            « Previous Visit
          </Link>
        )}
        <Link className="join-item btn btn-sm" to={`/visits/`}>
          My Visits
        </Link>

        {nextVisit && (
          <Link
            key={JSON.stringify(nextVisit)}
            className="join-item btn btn-sm"
            to={`/visits/${nextVisit["id"]}/details`}
            reloadDocument={true}
          >
            Next Visit »
          </Link>
        )}
      </div>
    </div>
  );
}
